export default {
  name: 'goldengoose',
  appId: 'wx11e85e2e647d89b7',
  wechatId: '126',
  baseUrl: 'https://egoldengoose.cn/'
};